export enum ResultadoDescadastroEnum {
  DESCADASTRADO = 'DESCADASTRADO',
  JA_DESCADASTRADO = 'JA_DESCADASTRADO',
  LINK_INVALIDO = 'LINK_INVALIDO',
}

export class DescadastroEmailResultado {
  resultado?: ResultadoDescadastroEnum;
  email?: string;
}
